import axios from 'axios';

const nerisApiUrl = process.env.REACT_APP_NERIS_API_URL;

export const apiNerisService = axios.create({
  baseURL: nerisApiUrl,
  headers: {
    Accept: 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Access-Control-Allow-Origin': '*',
  },
});

apiNerisService.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token');
    const department = localStorage.getItem('department');

    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }

    if (department) {
      config.headers.FirehouseID = department;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
